/* eslint-disable react/jsx-pascal-case */
import { GetStaticProps } from 'next';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';
import React from 'react';
import { useLocation } from 'react-use';

import CTA from '@/components/CTA';
import Banner from '@/components/English/Banner';
import Blog from '@/components/English/Blog';
import CourseFeatures from '@/components/English/CourseFeatures';
import CoursePackage from '@/components/English/CoursePackage';
// import CourseFeatures from '@/components/English/CourseFeatures';
import CourseSystem from '@/components/English/CourseSystem';
import ELA from '@/components/English/ELA';
import Teachers from '@/components/English/Teachers';
import VipClass from '@/components/English/VipClass';
// import { BLOG_URL } from '@/utils/constants';
// import { BlogPost } from '@/components/Home/home';
import Layout from '@/components/Layout';
import useIsMobile from '@/hooks/useIsMobile';

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  // let blogPosts: BlogPost[] = [];
  // try {
  //   // 获取所有类别
  //   const posts = await fetch(`${BLOG_URL}/wp-json/wp/v2/wk_get_blog_posts?lang=${locale}&per_page=3`);
  //   const postsData: BlogPost[] = await posts.json();
  //   blogPosts = postsData;
  // } catch (error) {
  //   console.log('blog err', error);
  // }

  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'home',
        'common',
        'english',
        'path',
      ])),
      // blogPosts: [...blogPosts],
    },
  };
};

// interface IProps {
//   blogPosts: BlogPost[];
// }

const English = () => {
  const { t } = useTranslation(['english', 'common']);
  const state = useLocation();
  const isMobile = useIsMobile();

  return (
    <>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t('common:seo-英文课程-title'),
          description: t('common:seo-英文课程-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t('common:seo-英文课程-title'),
            },
          ],
        }}
      />
      <Head>
        <title>{t('common:seo-英文课程-title')}</title>
        <meta
          name="description"
          content={t('common:seo-英文课程-description')}
        />
        <meta name="keywords" content={t('common:seo-英文课程-关键词')} />
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t('common:seo-英文课程-title')}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Course',
              name: t('common:seo-悟空英语阅读写作'), //填写当前学科页面的(WuKong Chinese/WuKong Math/WuKong ELA Class), 对应中文为（悟空中文、悟空数学、悟空英语阅读写作）
              description: t('common:seo-英文课程-description'), //填写当前学科页面的meta description
              provider: {
                '@type': 'Organization',
                name: t('common:seo-悟空教育'), //中文为悟空教育
                url: state?.href, //首页url， 区分中文英文
              },
              educationalLevel: t('common:seo-英文-年龄'), //中文为3-18岁
              learningResourceType: t('common:seo-英文-资源类型'), //1v1在线中文直播课
              url: state?.href, //当前学科页url
              mainEntityOfPage: {
                '@type': 'WebPage',
                url: state?.href, //当前学科页url
              },
              potentialAction: {
                '@type': 'ReserveAction',
                name: t('common:seo-英文-约课名称'), //填写对应学科页的约课名称，见下表
                target: {
                  '@type': 'EntryPoint',
                  urlTemplate: t('common:seo-英文-约课链接'), //填写对应学科页的约课链接，见下表
                  actionPlatform: [
                    'https://schema.org/DesktopWebPlatform',
                    'https://schema.org/MobileWebPlatform',
                  ],
                },
                description: t('common:seo-英文-约课描述'), //填写对应学科页的约课描述，见下表
              },
              offers: {
                '@type': 'Offer',
                price: '0',
                priceCurrency: 'USD',
                availability: 'https://schema.org/InStock',
              },
            }),
          }}
        />
      </Head>
      {/* banner */}
      <Banner />

      {/* 课程特色 CourseFeatures */}
      <CourseFeatures />

      {/* 师资力量 Teachers */}
      <Teachers />

      {/* 课程体系 */}
      <CourseSystem />

      {/* vip精英课 */}
      <VipClass />

      {/* ELA学员故事 */}
      <ELA />

      {/* 课包 */}
      <CoursePackage />

      {/* 博客 */}
      <Blog
        title={t('english:英文学科Blog', { br: isMobile ? ' ' : '<br/>' })}
      />

      <section className="marginModelTop  mb-20 lg:mb-[180px] xl:mb-[240px]">
        <CTA
          blockTitle="步骤之旅-标题"
          steps1name="步骤之旅-步骤-1"
          steps2name="步骤之旅-步骤-2"
          steps3name="步骤之旅-步骤-3"
          useTranslationName="english"
          subject="english"
        />
      </section>
    </>
  );
};

export default English;

English.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;
